module.exports = __webpack_public_path__ + "img/widget_0031.ac297e00.png";